/* eslint-disable */
// @ts-nocheck

const scriptSrc = () => {
  const host = window.location.hostname;

  if (/\.(yango\.com|yango-team\.com)$/.test(host)) {
    return "https://mc.yango.com/metrika/tag_yango.js";
  }

  if (/\.(yandex\.com|yandex-team\.com)$/.test(host)) {
    return "https://mcint.yandex.com/metrika/tag_com.js";
  }

  return "https://mc.yandex.ru/metrika/tag.js";
};

(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", scriptSrc(), "ym");

ym(97973751, "init", {
  clickmap: true,
  defer: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});
